module.exports = __webpack_public_path__ + "img/boiler-room.d68b0e0c.webp";